<template>
  <v-container>
    <v-row class="pr-5">
        <div class="main-layout">
          <v-row>
            <v-app-bar fixed class="toolbar">
              <v-toolbar-title>Budget Tool</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-app-bar>
          </v-row>
          <v-row>
            <v-col cols="12">
              <p>The Divorce Answered Budget Tool offers an insight into your income and expenditure - whether you are financially sound or whether adjustments are required. By using the budget tool, you see an overview of where your money is being spent.</p>
              <v-alert type="teal" class="text-center">
                A new and improved Budget Tool is on its way!<br>Please visit again soon.
              </v-alert>
            </v-col>
            <!-- <v-card>
              <v-card-text>
                <v-data-table
                  :headers="headers"
                  :items="income"
                  class="elevation-1"
                  hide-default-footer
                  hide-default-header
                >
                <template v-slot:body="{ items }">
                  <tr v-for="item in items" :key="item.name">
                    <template v-if="item.type == 'header'">
                      <td class="headers" width="30%">{{ item.name }}</td>
                      <td class="headers">Weekly</td>
                      <td class="headers">Fortnightly</td>
                      <td class="headers">Monthly</td>
                      <td class="headers">Quarterly</td>
                      <td class="headers">Yearly</td>
                    </template>
                    <template v-else>
                      <td>
                        <v-text-field v-if="item.isCustom"
                          type="text"
                          append-icon="close"
                          @click:append="removeItem(income, item)"
                          v-model="item.name"
                        ></v-text-field>
                        <span v-else>
                          {{ item.name }}
                        </span>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          type="number"
                          v-model="item.weekly"
                          placeholder="0"
                          prefix="$"
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          type="number"
                          @change="onFortnightlyChange($event, item)"
                          :value="fortnightly(item.weekly)"
                          prefix="$"
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          type="number"
                          @change="onMonthlyChange($event, item)"
                          :value="monthly(item.weekly)"
                          prefix="$"
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          type="number"
                          @change="onQuarterlyChange($event, item)"
                          :value="quarterly(item.weekly)"
                          prefix="$"
                        ></v-text-field>
                      </td>
                      <td class="text-right">
                        <v-text-field
                          type="number"
                          @change="onYearlyChange($event, item)"
                          :value="yearly(item.weekly)"
                          prefix="$"
                        ></v-text-field>
                      </td>
                    </template>
                  </tr>
                </template>
                <template v-slot:footer>
                  <tr>
                    <v-btn color="teal" dark @click="income.push({isCustom: true, weekly: 0})">+ Add Income</v-btn>
                  </tr>
                    <tr row pr-5>
                      <td><strong>Total Income</strong></td>
                      <td>{{totalWeekly(income)}}</td>
                      <td>{{totalFortnightly(income)}}</td>
                      <td>{{totalMonthly(income)}}</td>
                      <td>{{totalQuarterly(income)}}</td>
                      <td>{{totalYearly(income)}}</td>
                    </tr>
                </template>
                </v-data-table>
              </v-card-text>
            </v-card> -->
          </v-row>
          <!-- <v-row>
            <v-col>
              <app-activity-indicator v-if="loading"></app-activity-indicator>
              <v-expansion-panels v-else>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div class="subheading">Income</div>
                  <v-spacer></v-spacer>
                  Total Annual Income: ${{totalIncome}}
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-card>
                      <v-card-text>
                          <v-data-table
                            :headers="headers"
                            :items="income"
                            class="elevation-1"
                            hide-default-footer
                            hide-default-header
                          >
                          <template v-slot:items="props">
                            <template v-if="props.item.type == 'header'">
                              <td class="headers" width="30%">{{ props.item.name }}</td>
                              <td class="headers">Weekly</td>
                              <td class="headers">Fortnightly</td>
                              <td class="headers">Monthly</td>
                              <td class="headers">Quarterly</td>
                              <td class="headers">Yearly</td>
                            </template>
                            <template v-else>
                              <td>
                                <v-text-field v-if="props.item.isCustom"
                                  type="text"
                                  append-icon="close"
                                  @click:append="removeItem(income, props.item)"
                                  v-model="props.item.name"
                                ></v-text-field>
                                <span v-else>
                                  {{ props.item.name }}
                                </span>
                              </td>
                              <td class="text-right">
                                hello
                                <v-text-field
                                  type="number"
                                  v-model="props.item.weekly"
                                  placeholder="0"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onFortnightlyChange($event, props.item)"
                                  :value="fortnightly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onMonthlyChange($event, props.item)"
                                  :value="monthly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onQuarterlyChange($event, props.item)"
                                  :value="quarterly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onYearlyChange($event, props.item)"
                                  :value="yearly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                            </template>
                          </template>
                          <template v-slot:footer>
                            <tr>
                              <v-btn color="teal" dark @click="income.push({isCustom: true, weekly: 0})">+ Add Income</v-btn>
                            </tr>
                            <tr>
                              <td><strong>Total Income</strong></td>
                              <td>{{totalWeekly(income)}}</td>
                              <td>{{totalFortnightly(income)}}</td>
                              <td>{{totalMonthly(income)}}</td>
                              <td>{{totalQuarterly(income)}}</td>
                              <td>{{totalYearly(income)}}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="subheading">Real Estate</div>
                      <v-spacer></v-spacer>
                        Total Annual: ${{totalRealEstate}}
                    </template>
                    <v-card>
                      <v-card-text>
                          <v-data-table
                          :headers="headers"
                          :items="realEstate"
                          class="elevation-1"
                          hide-default-footer
                          hide-default-header
                        >
                          <template v-slot:items="props">
                            <template v-if="props.item.type == 'header'">
                              <td class="headers">{{ props.item.name }}</td>
                              <td class="headers text-right">Weekly</td>
                              <td class="headers">Fortnightly</td>
                              <td class="headers">Monthly</td>
                              <td class="headers">Quarterly</td>
                              <td class="headers">Yearly</td>
                            </template>
                            <template v-else>
                              <td>{{ props.item.name }}</td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  v-model="props.item.weekly"
                                  placeholder="0"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onFortnightlyChange($event, props.item)"
                                  :value="fortnightly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onMonthlyChange($event, props.item)"
                                  :value="monthly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onQuarterlyChange($event, props.item)"
                                  :value="quarterly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onYearlyChange($event, props.item)"
                                  :value="yearly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                            </template>
                          </template>
                          <template v-slot:footer>
                            <td><strong>Total Real Estate</strong></td>
                            <td>{{totalWeekly(realEstate)}}</td>
                            <td>{{totalFortnightly(realEstate)}}</td>
                            <td>{{totalMonthly(realEstate)}}</td>
                            <td>{{totalQuarterly(realEstate)}}</td>
                            <td>{{totalYearly(realEstate)}}</td>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="subheading">Automotive</div>
                      <v-spacer></v-spacer>
                        Total Annual: ${{totalAutomotive}}
                    </template>
                    <v-card>
                      <v-card-text>
                          <v-data-table
                          :headers="headers"
                          :items="automotive"
                          class="elevation-1"
                          hide-default-footer
                          hide-default-header
                        >
                          <template v-slot:items="props">
                            <template v-if="props.item.type == 'header'">
                              <td class="headers">{{ props.item.name }}</td>
                              <td class="headers">Weekly</td>
                              <td class="headers">Fortnightly</td>
                              <td class="headers">Monthly</td>
                              <td class="headers">Quarterly</td>
                              <td class="headers">Yearly</td>
                            </template>
                            <template v-else>
                              <td>{{ props.item.name }}</td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  v-model="props.item.weekly"
                                  placeholder="0"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onFortnightlyChange($event, props.item)"
                                  :value="fortnightly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onMonthlyChange($event, props.item)"
                                  :value="monthly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onQuarterlyChange($event, props.item)"
                                  :value="quarterly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onYearlyChange($event, props.item)"
                                  :value="yearly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                            </template>
                          </template>
                          <template v-slot:footer>
                            <td><strong>Total Automotive</strong></td>
                            <td>{{totalWeekly(automotive)}}</td>
                            <td>{{totalFortnightly(automotive)}}</td>
                            <td>{{totalMonthly(automotive)}}</td>
                            <td>{{totalQuarterly(automotive)}}</td>
                            <td>{{totalYearly(automotive)}}</td>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="subheading">Living Expenses</div>
                      <v-spacer></v-spacer>
                        Total Annual: ${{totalLivingExpenses}}
                    </template>
                    <v-card>
                      <v-card-text>
                          <v-data-table
                          :headers="headers"
                          :items="livingExpenses"
                          class="elevation-1 expense-table"
                          hide-default-footer
                          hide-default-header
                        >
                          <template v-slot:items="props">
                            <template v-if="props.item.type == 'header'">
                              <td class="headers">{{ props.item.name }}</td>
                              <td class="headers">Weekly</td>
                              <td class="headers">Fortnightly</td>
                              <td class="headers">Monthly</td>
                              <td class="headers">Quarterly</td>
                              <td class="headers">Yearly</td>
                            </template>
                            <template v-else>
                              <td>{{ props.item.name }}</td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  v-model="props.item.weekly"
                                  placeholder="0"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onFortnightlyChange($event, props.item)"
                                  :value="fortnightly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onMonthlyChange($event, props.item)"
                                  :value="monthly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onQuarterlyChange($event, props.item)"
                                  :value="quarterly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onYearlyChange($event, props.item)"
                                  :value="yearly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                            </template>
                          </template>
                          <template v-slot:footer>
                            <td><strong>Total Living Expenses</strong></td>
                            <td>{{totalWeekly(livingExpenses)}}</td>
                            <td>{{totalFortnightly(livingExpenses)}}</td>
                            <td>{{totalMonthly(livingExpenses)}}</td>
                            <td>{{totalQuarterly(livingExpenses)}}</td>
                            <td>{{totalYearly(livingExpenses)}}</td>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="subheading">Children</div>
                      <v-spacer></v-spacer>
                        Total Annual: ${{totalChildren}}
                    </template>
                    <v-card>
                      <v-card-text>
                          <v-data-table
                          :headers="headers"
                          :items="children"
                          class="elevation-1 expense-table"
                          hide-default-footer
                          hide-default-header
                        >
                          <template v-slot:items="props">
                            <template v-if="props.item.type == 'header'">
                              <td class="headers">{{ props.item.name }}</td>
                              <td class="headers">Weekly</td>
                              <td class="headers">Fortnightly</td>
                              <td class="headers">Monthly</td>
                              <td class="headers">Quarterly</td>
                              <td class="headers">Yearly</td>
                            </template>
                            <template v-else>
                              <td>
                                <v-text-field v-if="props.item.isCustom"
                                  type="text"
                                  append-icon="close"
                                  @click:append="removeItem(children, props.item)"
                                  v-model="props.item.name"
                                ></v-text-field>
                                <span v-else>
                                  {{ props.item.name }}
                                </span>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  v-model="props.item.weekly"
                                  placeholder="0"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onFortnightlyChange($event, props.item)"
                                  :value="fortnightly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onMonthlyChange($event, props.item)"
                                  :value="monthly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onQuarterlyChange($event, props.item)"
                                  :value="quarterly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                              <td class="text-right">
                                <v-text-field
                                  type="number"
                                  @change="onYearlyChange($event, props.item)"
                                  :value="yearly(props.item.weekly)"
                                  prefix="$"
                                ></v-text-field>
                              </td>
                            </template>
                          </template>
                          <template v-slot:footer>
                            <tr>
                              <v-btn color="teal" dark @click="children.push({isCustom: true, weekly: 0})">+ Add Other Expenses</v-btn>
                            </tr>
                            <tr>
                              <td><strong>Total Children</strong></td>
                              <td>{{totalWeekly(children)}}</td>
                              <td>{{totalFortnightly(children)}}</td>
                              <td>{{totalMonthly(children)}}</td>
                              <td>{{totalQuarterly(children)}}</td>
                              <td>{{totalYearly(children)}}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
                <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="subheading">Summary</div>
                      <v-spacer></v-spacer>
                        Total Annual Surplus: ${{totalYearly(income) - totalYearly(realEstate) - totalYearly(automotive) - totalYearly(livingExpenses) - totalYearly(children)}}
                    </template>
                    <v-card>
                      <v-card-text>
                          <v-data-table
                          :headers="headers"
                          :items="summary"
                          class="elevation-1 expense-table"
                          hide-default-footer
                          hide-default-header
                        >
                          <template v-slot:items="props">
                            <template v-if="props.item.type == 'header'">
                              <td class="headers">{{ props.item.name }}</td>
                              <td class="headers">Weekly</td>
                              <td class="headers">Fortnightly</td>
                              <td class="headers">Monthly</td>
                              <td class="headers">Quarterly</td>
                              <td class="headers">Yearly</td>
                            </template>
                          </template>
                          <template v-slot:footer>
                            <tr>
                              <td><strong>Total Income</strong></td>
                              <td>${{totalWeekly(income)}}</td>
                              <td>${{totalFortnightly(income)}}</td>
                              <td>${{totalMonthly(income)}}</td>
                              <td>${{totalQuarterly(income)}}</td>
                              <td>${{totalYearly(income)}}</td>
                            </tr>
                            <tr>
                              <td><strong>Total Expenses</strong></td>
                              <td>${{totalWeekly(realEstate) + totalWeekly(automotive) + totalWeekly(livingExpenses)+ totalWeekly(children)}}</td>
                              <td>${{totalFortnightly(realEstate) + totalFortnightly(automotive) + totalFortnightly(livingExpenses) + totalFortnightly(children)}}</td>
                              <td>${{totalMonthly(realEstate) + totalMonthly(automotive) + totalMonthly(livingExpenses) + totalMonthly(children)}}</td>
                              <td>${{totalQuarterly(realEstate) + totalQuarterly(automotive) + totalQuarterly(livingExpenses) + totalQuarterly(children)}}</td>
                              <td>${{totalYearly(realEstate) + totalYearly(automotive) + totalYearly(livingExpenses) + totalYearly(children)}}</td>
                            </tr>
                            <tr>
                              <td><strong>Surplus</strong></td>
                              <td>${{totalWeekly(income) - totalWeekly(realEstate) - totalWeekly(automotive) - totalWeekly(livingExpenses) - totalWeekly(children)}}</td>
                              <td>${{totalFortnightly(income) - totalFortnightly(realEstate) - totalFortnightly(automotive) - totalFortnightly(livingExpenses) - totalFortnightly(children)}}</td>
                              <td>${{totalMonthly(income) - totalMonthly(realEstate) - totalMonthly(automotive) - totalMonthly(livingExpenses) - totalMonthly(children)}}</td>
                              <td>${{totalQuarterly(income) - totalQuarterly(realEstate) - totalQuarterly(automotive) - totalQuarterly(livingExpenses) - totalQuarterly(children)}}</td>
                              <td>${{totalYearly(income) - totalYearly(realEstate) - totalYearly(automotive) - totalYearly(livingExpenses) - totalYearly(children)}}</td>
                            </tr>
                          </template>
                        </v-data-table>
                      </v-card-text>
                    </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
          </v-row> -->
        </div>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
    activeTab: null,
    headers: [
      {
        align: 'left',
        sortable: false,
        value: 'name',
        width: '40%'
      },
      { text: 'Weekly', value: 'weekly', sortable: false },
      { text: 'Fornightly', value: 'fortnightly', sortable: false },
      { text: 'Monthly', value: 'Monthly', sortable: false },
      { text: 'Quarterly', value: 'quarterly', sortable: false },
      { text: 'Yearly', value: 'yearly', sortable: false }
    ]
  }),
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    income () {
      return this.$store.getters['budgetToolStore/income']
    },
    realEstate () {
      return this.$store.getters['budgetToolStore/realEstate']
    },
    automotive () {
      return this.$store.getters['budgetToolStore/automotive']
    },
    livingExpenses () {
      return this.$store.getters['budgetToolStore/livingExpenses']
    },
    children () {
      return this.$store.getters['budgetToolStore/children']
    },
    summary () {
      return this.$store.getters['budgetToolStore/summary']
    },
    totalIncome () {
      return this.totalYearly(this.income)
    },
    totalRealEstate () {
      return this.totalYearly(this.realEstate)
    },
    totalAutomotive () {
      return this.totalYearly(this.automotive)
    },
    totalLivingExpenses () {
      return this.totalYearly(this.livingExpenses)
    },
    totalChildren () {
      return this.totalYearly(this.children)
    }
  },
  methods: {
    removeItem (array, item) {
      var index = array.indexOf(item)
      confirm('Are you sure you want to remove this item?') && array.splice(index, 1)
    },
    totalWeekly (items) {
      var total = 0
      items.forEach(element => {
        if (/\S/.test(element.weekly)) {
          total += parseFloat(element.weekly)
        }
      })
      return total
    },
    totalFortnightly (items) {
      var total = 0
      items.forEach(element => {
        if (/\S/.test(element.weekly)) {
          // string is not empty and not just whitespace
          total += parseInt(element.weekly) * 2
        }
      })
      return total
    },
    totalMonthly (items) {
      var total = 0
      items.forEach(element => {
        total += Math.ceil((parseInt(element.weekly) * 52) / 12)
      })
      return total
    },
    totalQuarterly (items) {
      var total = 0
      items.forEach(element => {
        total += Math.ceil((parseInt(element.weekly) * 52) / 4)
      })
      return total
    },
    totalYearly (items) {
      var total = 0
      items.forEach(element => {
        total += parseInt(element.weekly) * 52
      })
      return total
    },
    fortnightly (value) {
      return Math.ceil(value * 2)
    },
    monthly (value) {
      return Math.ceil((value * 52) / 12)
    },
    quarterly (value) {
      return Math.ceil((value * 52) / 4)
    },
    yearly (value) {
      return Math.ceil(value * 52)
    },
    onFortnightlyChange (event, item) {
      item.weekly = Math.ceil(parseInt(event) / 2)
    },
    onMonthlyChange (event, item) {
      item.weekly = Math.ceil((parseInt(event) * 12) / 52)
    },
    onQuarterlyChange (event, item) {
      item.weekly = Math.ceil((parseInt(event) * 4) / 52)
    },
    onYearlyChange (event, item) {
      item.weekly = Math.ceil(parseInt(event) / 52)
    }
  }
}
</script>

<style scoped>
.toolbar {
  top: 64px;
}
.main-layout {
  margin-top: 64px;
}
td.headers {
  text-transform: uppercase;
  color: #ffffff;
  background-color: #009688;
  font-weight: bold;
}
</style>
